import type { SelectStatusProps } from './types';
import SetupGridItem from '../../containers/ViewProperty/SetupGridItem';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import React, { useMemo } from 'react';
import { SingleSelect } from '@fortress-technology-solutions/fortress-component-library/Molecules';

export default function SelectStatus(props: SelectStatusProps) {
  const selectedText: string = useMemo(() => {
    const selectedOption = props.options.find(
      (option) => option.value === props.selected,
    );

    if (!selectedOption) {
      return props.options[0].text;
    }

    return selectedOption.text;
  }, [props.selected]);
  return (
    <SetupGridItem label={props.label}>
      {props.enableEdit ? (
        <SingleSelect
          {...props.selectProps}
          options={props.options}
          value={props.selected}
        />
      ) : (
        <Typography>{selectedText}</Typography>
      )}
    </SetupGridItem>
  );
}
